import type { LocaleResources } from 'locales';
import React from 'react';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import { ModalIcon, iconType } from 'src/components/shared/elements/modals/ModalIcon';
import { NextImage } from 'src/components/shared/elements/NextImage';
import { authorize } from 'src/utils/authorize';
import { mixpanel } from 'src/utils/mixpanel';
import { toJSX } from 'src/utils/toJSXHelper';
import styles from './index.module.scss';

type Props = {
  title: string;
  localeResources: LocaleResources;
  closeModal: () => void;
};

export const Presenter: React.FC<Props> = ({ title, localeResources, closeModal }) => (
  <CommonModal
    closeModal={closeModal}
    fixedElement={
      <>
        <ModalIcon type={iconType.LOGIN} />
        <div className={styles.title}>{title}</div>
        <button className={styles.button} onClick={() => authorize('signIn')}>
          <label>{localeResources.auth.signIn}</label>
        </button>
        <div className={styles.registerContainer}>
          {localeResources.auth.accountNotYet}
          <span>{toJSX(localeResources.registerCampaign.signUpAndGetCoupon(styles.pink))}</span>
          <span
            className={styles.registerWrap}
            onClick={() => {
              mixpanel.onAccountRegistration();
              authorize('signUp');
            }}
          >
            <NextImage src="/kaimono/images/favicon-256x256.webp" alt="WAmazing" width={16} height={14} />
            <div className={styles.register}>{localeResources.auth.signUpNow}</div>
          </span>
        </div>
      </>
    }
  />
);
